import React from "react";
import { ArrowRight } from "lucide-react";
import CommonButton from "../../ui/inputs/CommonButton.js";
import { Box } from "@mui/material";
import { heroArrowAnimation } from "../index.js";
import { Path } from "../../../../static/Constants";

const HeroActions = ({ history }) => {
  return (
    <Box
      className="home-hero-actions"
      sx={{
        display: "flex",
        gap: { xs: 1.25, sm: 2, md: 3 },
        flexWrap: "wrap",
        width: "100%",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", sm: "center" },
      }}
    >
      <CommonButton
        variant="contained"
        size="hero"
        onClick={() => history.push(Path.allLotteries)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1.5,
          ...heroArrowAnimation,
        }}
      >
        Browse all games
        <Box
          component="span"
          className="hero-arrow"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "visible",
            width: "18px",
            height: "18px",
            flexShrink: 0,
            color: (theme) => theme.palette.primary.contrastText,
          }}
        >
          <ArrowRight size={18} strokeWidth={2.5} />
        </Box>
      </CommonButton>
    </Box>
  );
};

export default HeroActions;